export const NUMBER_UNDEFINED = -313373;
export const STRING_UNDEFINED = '-';
export const NEW_ITEM_URL_ID = 'create';
